/* eslint-disable id-match */
export const minimumPhoneNumberLength = 7;
export const debounceDelay = 800;

export const cacheKey = {
  JOB_CHAT_ID: 'jobChatId',
  TOKEN: '_jc_token',
  KEEP_WIDGET_CLOSED: '_jc_remain_closed',
  REAL_TIME_TICKET_ID: '_ticket_id',
  REFRESH_TOKEN_INTERVAL_ID: 'refreshTokenIntervalId',
};

export const sessionState = {
  ACTIVE: 'active',
  INACTIVE: 'inactive',
  FAILED: 'failed',
};
